<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="margin-top10" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentYear'" v-model="dateRange" ref="dateRangeSelect" /></div>
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <div v-show="lsDados.length>0" class="table-wrapper"><table>
            <thead>
                <tr>
                    <th>Despesa</th>
                    <th>Data</th>
                    <th>Nro Doc</th>
                    <th>Tipo Despesa</th>
                    <th>Equipamento</th>
                    <th>Km/Horas</th>
                    <th>Quantidade</th>
                    <th>Valor</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                    @click="setEdicao(obj)"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cddespesa) }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtdespesa) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.docnro) }}</td>
                    <td>{{ obj.nmdespesagrupo }}</td>
                    <td class="col-width-char40">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.kmhoras) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.vldespesa) }}</td>
                </tr>
            </tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <div v-if="modoEdicao">
        <DespesasEditPage @close="modoEdicao = false" @salvo="lerDados" />
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import DespesasEditPage from '../formularios/DespesasEditPage.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit= defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const equipamentoSelecionado = ref(null);
const showPagination = ref(false);


const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);


const closeForm = () => {emit('close');}


const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/dados/despesas', {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipamentoSelecionado.value?.id,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


const novoCadastro = () => {
    modoEdicao.value = true;
}


function setEdicao(obj){
    console.log(obj);
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}
</script>
